const get = require('lodash/get')
const PGAdapter = require('../common/pg-adapter')
const api = require('./api')
const { wrapEntityApi } = require('../utils/wrap-api')
const tools = require('./tools')

const rawMethods = {
  list: api.listPrograms,
  listByIds: api.listProgramsByIds,
  get: api.getProgram,
  save: api.createProgram,
  update: api.updateProgram,
  addService: api.addService,
  tools
}

class ProgramApi {
  constructor (state, logger, pgConnection) {
    const apiMethods = wrapEntityApi(rawMethods, state)
    Object.assign(this, apiMethods)

    if (pgConnection) {
      const username = get(state, 'user.name')
      this.pgAdapter = new ProgramPgAdapter({ pgConnection, username, logger })
    }
  }
}

class ProgramPgAdapter extends PGAdapter {
  constructor ({ pgConnection, username, logger }) {
    const columns = [
      'id',
      'fsid',
      'name',
      'options',
      'created_at',
      'updated_at'
    ]
    super(pgConnection, 'avocado.data_program', username, columns, 'id', {}, logger)
  }
}
module.exports = rawMethods
module.exports.ProgramApi = ProgramApi
